
import React, { useState, useContext, useEffect } from "react";
import AuthContext from 'context/AuthProvider';
import Toast from 'light-toast';
import { USER_ICON, SIGN_OUT_ICON, FAVOURITE_ICON, HOME_ICON, CHART_ICON, EXPORT_ICON, BAR_ICON, TIMES_CIRCLE_ICON, USER_PLUS_ICON, TASK_ICON, ACCOUNT_ICON, HELP_ICON, HISTORY_ICON, SEARCH_ICON, PAYMENT_ICON } from "assets/constants/Icons";
import { ProSidebar, Menu, MenuItem, SidebarHeader, SidebarContent, SidebarFooter, SubMenu } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { hasRoutePermission } from "components/Permission";

function SideNavigationBar(props) {
    const authContext = useContext(AuthContext);
    const userDetail = JSON.parse(localStorage.getItem("userData"));
    const userRole = JSON.parse(localStorage.getItem("userRole"));
    const [menuCollapse, setMenuCollapse] = useState(true);
    const [hideNavbar] = useState(window.location.href.includes("/step-complete") ? true : false);

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            /* Increase Outer Shadow for the Sidebar */
            .pro-sidebar {
                box-shadow: 10px 0 25px -5px rgba(0, 0, 0, 0.2), 5px 0 10px -5px rgba(0, 0, 0, 0.1) !important;
                z-index: 1000;
            }

            /* Hide scrollbar for Chrome, Safari and Opera */
            .hide-scrollbar::-webkit-scrollbar,
            .pro-sidebar-inner::-webkit-scrollbar,
            .pro-sidebar-content::-webkit-scrollbar,
            .pro-sidebar-inner .pro-sidebar-layout::-webkit-scrollbar {
                display: none !important;
            }

            /* Hide scrollbar for IE, Edge and Firefox */
            .hide-scrollbar,
            .pro-sidebar-inner, 
            .pro-sidebar-content,
            .pro-sidebar-inner .pro-sidebar-layout {
                -ms-overflow-style: none !important;
                scrollbar-width: none !important;
            }

            /* Ensure hover submenus are not clipped */
            .pro-sidebar-inner {
                overflow: visible !important;
            }
        `;
        document.head.appendChild(style);
        return () => document.head.removeChild(style);
    }, []);

    const editUserHandler = (userDetail) => {
        props.history.push({
            pathname: "/create-user-page",
            state: { ...userDetail, isFromProfile: true }
        });
    }

    const menuIconClick = () => {
        setMenuCollapse(!menuCollapse);
        if (!authContext.isAuthenticated()) {
            Toast.fail('You are not logged in. Please Login!', 3000, () => {
                window.location.href = "/login-page";
            });
        }
    };

    return (
        userDetail && (
            <div className={`side-navigation-bar ${hideNavbar === true ? "display-none" : ""}`}>
                <div className="side-navigation-bar-hamburger-button" onClick={menuIconClick}>
                    {(menuCollapse) && (<span className={`${BAR_ICON} side-navigation-bar-icon`} aria-hidden="true"></span>)}
                    {(!menuCollapse) && (<span className={`${TIMES_CIRCLE_ICON} side-navigation-bar-icon`} aria-hidden="true"></span>)}
                </div>
                <div className="side-navigation-bar-content">
                    <ProSidebar collapsed={menuCollapse} breakPoint="md" rtl={false}>
                        <SidebarHeader>
                            {userDetail && (
                                <Menu iconShape="circle">
                                    <MenuItem icon={<i className={`${USER_ICON} side-navigation-bar-icon`}></i>} onClick={() => editUserHandler(userDetail)} title="Edit user information">
                                        <span>{`Hi, ${userDetail.first_name} `}</span>
                                        <span>{userDetail.total_credit}</span>
                                        <span>{`(${userRole.user_role})`}</span>
                                    </MenuItem>
                                </Menu>
                            )}
                        </SidebarHeader>

                        <SidebarContent className="hide-scrollbar" style={{ height: '70vh', overflowY: 'auto', overflowX: 'visible' }}>
                            <Menu iconShape="square">
                                {hasRoutePermission("/home-page") && (
                                    <MenuItem icon={<i className={`${HOME_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Projects">
                                        <a className="side-navigation-bar-menu-title" href="/home-page">Home</a>
                                    </MenuItem>
                                )}
                                {hasRoutePermission('/home-page') && (
                                    <MenuItem icon={<i className={`${SEARCH_ICON} side-navigation-bar-icon`} aria-hidden='true'></i>} title='Search Product'>
                                        <a className='side-navigation-bar-menu-title' href='/search-product'>Search Product</a>
                                    </MenuItem>
                                )}

                                <SidebarFooter>
                                    <Menu>
                                        {hasRoutePermission("/user-page") && (
                                            <SubMenu id="side-navigation-bar-sub-menu-user" className={menuCollapse === true ? `side-navigation-bar-sub-menu-user` : ""} icon={<i className={`${USER_PLUS_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="User">
                                                <MenuItem><a className="side-navigation-bar-menu-title" href="/user-page"> User Master</a></MenuItem>
                                                {hasRoutePermission("/roles-page") && (
                                                    <MenuItem><a className="side-navigation-bar-menu-title" href="/roles-page">Role</a></MenuItem>
                                                )}
                                            </SubMenu>
                                        )}
                                    </Menu>
                                </SidebarFooter>
                                {hasRoutePermission("/favourite-page") && (
                                    <MenuItem icon={<i className={`${FAVOURITE_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Favourites">
                                        <a className="side-navigation-bar-menu-title" href="/favourite-page">Favourites</a>
                                    </MenuItem>
                                )}
                                {hasRoutePermission("/chatt-page") && (
                                    <MenuItem icon={<i className={`${CHART_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Notifications">
                                        <a className="side-navigation-bar-menu-title" href="/chatt-page">Notifications</a>
                                    </MenuItem>
                                )}
                                {hasRoutePermission("/export-page") && (
                                    <MenuItem icon={<i className={`${EXPORT_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Exports">
                                        <a className="side-navigation-bar-menu-title" href="/export-page">Exports</a>
                                    </MenuItem>
                                )}
                                <SidebarFooter>
                                    <Menu>
                                        {hasRoutePermission("/payment/transactions") && (
                                            <SubMenu id="side-navigation-bar-sub-menu-user" className={menuCollapse === true ? `side-navigation-bar-sub-menu-user` : ""} icon={<i className={`${PAYMENT_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Payments">
                                                <MenuItem><a className="side-navigation-bar-menu-title" href="/payment/transactions"> Payment Transactions</a></MenuItem>
                                                {hasRoutePermission("/payment/pay") && (
                                                    <MenuItem><a className="side-navigation-bar-menu-title" href="/payment/pay">Make Payment</a></MenuItem>
                                                )}
                                            </SubMenu>
                                        )}
                                    </Menu>
                                </SidebarFooter>
                                <SidebarFooter>
                                    <Menu>
                                        {hasRoutePermission("/workplace") && (
                                            <SubMenu id="side-navigation-bar-sub-menu-user" className={menuCollapse === true ? `side-navigation-bar-sub-menu-user` : ""} icon={<i className={`${TASK_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Workplace">
                                                <MenuItem><a className="side-navigation-bar-menu-title" href="/workplace"> Workplace</a></MenuItem>
                                                {hasRoutePermission("/subscription") && (
                                                    <MenuItem><a className="side-navigation-bar-menu-title" href="/subscription">Plan & Subscription</a></MenuItem>
                                                )}
                                                {hasRoutePermission("/workplace") && (
                                                    <MenuItem><a className="side-navigation-bar-menu-title" href="/workplace">Team</a></MenuItem>
                                                )}
                                                {hasRoutePermission("/pricing-model") && (
                                                    <MenuItem><a className="side-navigation-bar-menu-title" href="/pricing-model">Pricing Model</a></MenuItem>
                                                )}
                                                {hasRoutePermission("/credit-usage") && (
                                                    <MenuItem><a className="side-navigation-bar-menu-title" href="/credit-usage">Profile & Credit Usage</a></MenuItem>
                                                )}
                                                {hasRoutePermission("/referral-page") && (
                                                    <MenuItem><a className="side-navigation-bar-menu-title" href="/referral-page">Referrals</a></MenuItem>
                                                )}
                                            </SubMenu>
                                        )}
                                    </Menu>
                                </SidebarFooter>

                                {hasRoutePermission("/account") && (
                                    <MenuItem icon={<i className={`${ACCOUNT_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Account">
                                        <a className="side-navigation-bar-menu-title" href="/account">Account</a>
                                    </MenuItem>
                                )}

                                {hasRoutePermission("/history") && (
                                    <MenuItem icon={<i className={`${HISTORY_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="History">
                                        <a className="side-navigation-bar-menu-title" href="/history">History</a>
                                    </MenuItem>
                                )}

                                {hasRoutePermission("/help-support") && (
                                    <MenuItem icon={<i className={`${HELP_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Help & Support">
                                        <a className="side-navigation-bar-menu-title" href="/help-support">Help & Support</a>
                                    </MenuItem>
                                )}
                            </Menu>
                        </SidebarContent>

                        <SidebarFooter>
                            <Menu>
                                <MenuItem icon={<i className={`${SIGN_OUT_ICON} side-navigation-bar-icon`} aria-hidden="true"></i>} title="Logout" onClick={authContext.signOut}>
                                    <span>Logout</span>
                                </MenuItem>
                            </Menu>
                        </SidebarFooter>
                    </ProSidebar>
                </div>
            </div>
        )

        );
};

export default SideNavigationBar;
